// src/services/authService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const authService = {
  async signIn(authData) {
    return await api.post("/login", authData);
  },

  async signUp(authData) {
    return await api.post("/register", authData);
  },

  async logout() {
    return await api.post("/logout", { }, { headers: authHeader() });
  },

  async forgotPassword(authData) {
    return await api.post("/forgot-password", authData);
  },

  async resetPassword(authData) {
    return await api.post("/reset-password", authData);
  },

  async me(authData) {
    return await api.post("/me", { }, { headers: authHeader() });
  },
};

export default authService;
